<script setup lang="ts">
import { computed } from 'vue';

import LightBox from '@/components/Lightbox/LightBox.vue';

import ChatMessageWrapper from './ChatMessageWrapper.vue';
import { MediaMessage } from '@/common/bot/types/messages/MediaMessage';

export interface ArticlePreviewMessageProps {
  message: MediaMessage;
  /**
   * The previous message/notice in the stack.
   */
  previous?: unknown;
  /**
   * The next message/notice in the stack.
   */
  next?: unknown;
}

const props = defineProps<ArticlePreviewMessageProps>();

const isImage = computed(() => /^image/.test(props.message.attachment.contentType));
</script>

<template>
  <ChatMessageWrapper :previous="previous" :next="next" :message="message">
    <LightBox v-if="isImage">
      <a :href="message.attachment.url" class="chat-img-container">
        <img class="chat-img" :src="message.attachment.url" />
      </a>
    </LightBox>
    <a
      v-else
      :href="message.attachment.url"
      :download="message.attachment.name || true"
      class="no-underline"
      target="_blank"
    >
      <div class="chat-msg">
        <strong>⬇️ Download:</strong><br />
        <!-- :style="attachmentNameStyle" -->
        <span>
          {{ message.attachment.name }}
        </span>
      </div>
    </a>
  </ChatMessageWrapper>
</template>
